export function constructUrl(
  marketingUrl: string | undefined,
  getUrl: (url: string) => string | undefined,
): string {
  if (!marketingUrl) return "/";

  // If it's already a full URL, use it as-is
  if (
    marketingUrl.startsWith("http://") ||
    marketingUrl.startsWith("https://")
  ) {
    return getUrl(marketingUrl) || marketingUrl;
  }

  // If it's a relative URL, ensure it starts with "/"
  const relativeUrl = marketingUrl.startsWith("/")
    ? marketingUrl
    : `/${marketingUrl}`;
  return getUrl(relativeUrl) || relativeUrl;
}
